import { Stack } from '@vapor/material'
import { HICLoading } from 'hic-components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useThreadsQuery, useUpdateThreadMutation } from 'src/api/api.generated'
import Chat from 'src/app/components/chat/chat'
import { useProperty } from 'src/app/hooks/context/context.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/error-snack-bar'
import FormLayoutDrawer from 'src/app/layout/form-layout/form-layout-drawer'
import { FormLayoutDefaultToolbar } from 'src/app/layout/form-layout/form-layout-toolbar'

export default function ChatDrawer({ threadId, open, onClose }: { threadId: string; open: boolean; onClose: () => void }) {
  const { t } = useTranslation()
  const property = useProperty()
  const showError = useErrorSnackBar()

  const [updateThread, { loading: loadingMutation }] = useUpdateThreadMutation({
    onError: showError,
  })
  const { data, loading } = useThreadsQuery({
    variables: {
      filter: {
        propertyId: property?.id ?? '',
        tenantId: property?.tenantId ?? '',
        id: threadId,
      },
    },
    onError: showError,
  })

  const thread = data?.threads?.[0]
  const backgroundColor = thread?.archived ? 'var(--Gainsboro)' : 'var(--White)'

  useEffect(() => {
    if (thread && !thread.read) {
      updateThread({
        variables: {
          input: {
            tenantId: property?.tenantId ?? '',
            threadId: thread.id,
            read: true,
            archived: thread.archived,
          },
        },
      })
    }
  }, [thread])

  return (
    <FormLayoutDrawer
      title={t('pms.mail_log_drawer.chat')}
      open={open}
      onClose={onClose}
      tight
      toolbar={
        <FormLayoutDefaultToolbar
          cancelButton={{
            text: t('commons.close'),
            clickHandler: onClose,
          }}
        />
      }
    >
      {(loading || loadingMutation) && <HICLoading />}
      <Stack direction="column" height="100%">
        <Chat
          propertyId={property?.id ?? ''}
          tenantId={property?.tenantId ?? ''}
          thread={thread ?? null}
          backgroundColor={backgroundColor}
          insideReservation
          onArchive={
            thread && !thread.archived
              ? () => {
                  updateThread({
                    variables: {
                      input: {
                        tenantId: property?.tenantId ?? '',
                        threadId: thread.id,
                        archived: true,
                        read: thread.read,
                      },
                    },
                  })
                }
              : undefined
          }
          onInbox={
            thread && thread?.archived
              ? () => {
                  updateThread({
                    variables: {
                      input: {
                        tenantId: property?.tenantId ?? '',
                        threadId: thread.id,
                        archived: false,
                        read: thread.read,
                      },
                    },
                  })
                }
              : undefined
          }
          onToBeRead={
            thread
              ? () => {
                  updateThread({
                    variables: {
                      input: {
                        tenantId: property?.tenantId ?? '',
                        threadId: thread.id,
                        archived: thread.archived,
                        read: false,
                      },
                    },
                  })
                }
              : undefined
          }
        />
      </Stack>
    </FormLayoutDrawer>
  )
}
